import { PropsWithChildren } from 'react'
import Styles from './Tag.module.scss'
import { ReactComponent as CloseIcon } from 'assets/icons/close16.svg'
import { fillColor } from 'common/PropertyForm/ColorInput'
import cx from 'classnames'

export type TagProps = {
  color: string
  onRemove?: () => void
  size?: 'md' | 'sm'
  fontColor?: string
  border?: string
}

export const Tag = ({
  children,
  color,
  fontColor,
  onRemove,
  size = 'md',
  border,
  ...props
}: PropsWithChildren<TagProps>) => {
  return (
    <div
      data-tag
      className={cx(Styles.tag, Styles[size])}
      style={{ backgroundColor: color, color: fontColor || fillColor(color), border }}
      {...props}
    >
      <div className={Styles.tagText}>{children}</div>
      {onRemove && (
        <button onClick={onRemove}>
          <CloseIcon />
        </button>
      )}
    </div>
  )
}
